import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
ulDefault: {
    padding: 0,
    margin: 0,
    marginBottom: theme.spacing.unit,
    transition: 'all 2s ease',
    marginTop:'-14px'
},
listItem: {
    display: 'inline-block',
    paddingTop: 0,
    paddingBottom: 0,
},
linkItem: {
    ...theme.typography.body1,
    textDecoration: 'none',
    fontSize:"12px",
    '&.active, &:active, &:focus, &:hover': {
        color: theme.palette.primary.main,
        textDecoration: 'underline',
    }
}, marginBottom1x: {
    marginBottom: theme.spacing.unit,
},
marginBottom2x: {
    position: 'relative',
    marginBottom: theme.spacing.unit * 2,
    width:"100%",
    boxShadow:"none",
    marginTop:theme.spacing.unit
},
currentLevel: {
    textTransform: 'capitalize',
    paddingLeft: theme.spacing.unit,
    paddingBottom: 4,
    transition: 'all 2s ease',
    maxHeight: 'auto'
},
cardContentRoot: {
    padding: theme.spacing.unit,
    '&:last-child': {
        paddingBottom: theme.spacing.unit,
    },
},
navigationButtonRoot: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    marginBottom: '10px',
    height: theme.spacing.unit * 5,
    '& > span': {
        width: '151px',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.fontSize
    },
    '& span  span': {
        paddingLeft: theme.spacing.unit / 2,
        paddingRight: theme.spacing.unit / 2,
        top: '2px',
        right: '2px',
        fontSize: '0.6rem',
    }
},
buttonTag: {
    position: 'absolute',
    top: theme.spacing.unit / 2,
    right: theme.spacing.unit,
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    borderRadius: theme.spacing.unit,
    padding: theme.spacing.unit,
    paddingTop: 0,
    paddingBottom: 0,
},
goalScrolled: {
   
    transition: 'all 2s ease',
},
padding0:{
    padding:0
},
floatLeft:{
    float:"left",
    fontSize:"15px"
},
floatLeftText:{
    float: "left",
    lineHeight: "45px",
    fontSize:"15px"
},
chaptersDiv: {
    float: "left",
    padding: "0px 13px 0px 0px",
    margin:"5px",
    borderRadius: "3px",
    border: "1px solid #DFDFDF",
    "&:hover": {
        background: "#efefef"
    },
    cursor: "pointer",
    listStyle:"none",
    boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.170884)"
},
'chaptersDiv:hover': {
    backgroundColor: "blue"
},
icons:{
    marginLeft: "10px",
    fontSize: "25px",
    marginTop:"-3px"
},
iconBreads:{
    marginTop:"-3px"
},
marginLeft5:{
    marginLeft:"5px"
},
floatleftCourse:{
    float: "left",
    lineHeight: "40px",
    marginLeft:"10px",
    fontSize:"15px"
},checkboxCSS: {
    color: "#dfdfdf",
    '&$checked': {
        color: "#43A047",
    },
},
checked: {},
});